import { error } from '../app/logger.js';
import { services } from '../app/services.js';
import { Picture } from '../data/picture.js';
import { HTMLControl } from '../controls/html_control.js';
import {
  reportPicShrinkError,
  reportPicUploadError,
} from '../ui/report_error.js';
import { window } from '../window.js';

import '../controls/image_editable_list.js';

/**
 * A wrapper around an editable list control of pictures, which
 * allows to add, remove or rearrange images and also upload images
 * on the server.
 **/
class PicUploadList extends HTMLControl {
  constructor() {
    super();
    this._pics = [];
  }

  static properties = {
    pics: {
      set(v) {
        this.listElement.set(Picture.toThumbnailUrls(v));
      },
    },
  };

  getItemElementAt(index) {
    return this.listElement.getItemElementAt(index);
  }

  initialize() {
    super.initialize();

    this.listElement.addEventListener('iteminsert', ev =>
      Promise.all(ev.detail.map(detailItem => this.grabPic(detailItem)))
    );
    this.listElement.addEventListener('itemremove', ev =>
      this._pics.splice(ev.detail.index, 1)
    );
    this.listElement.addEventListener('itemreorder', ev => {
      let swap = this._pics[ev.detail.oldIndex];
      this._pics[ev.detail.oldIndex] = this._pics[ev.detail.newIndex];
      this._pics[ev.detail.newIndex] = swap;
    });
    this.listElement.addEventListener('itemselect', ev =>
      this.dispatchEvent(
        new CustomEvent('picselect', {
          detail: ev.detail,
        })
      )
    );
  }

  static markup = `<image-editable-list></image-editable-list>`;

  static selectors = {
    List: 'image-editable-list',
  };

  static elements = {
    listElement: this.selectors.List,
  };

  async grabPic({ info, item }) {
    try {
      let { meta, url } = info;

      item.busy = true;
      let picid = await services.location.uploadPicture(
        url.split(',')[1],
        meta
      );
      item.busy = false;

      if (picid === null) {
        item.remove();
        reportPicUploadError();
        return;
      }

      this._pics.push(picid);

      this.dispatchEvent(
        new CustomEvent('picupload', {
          detail: {
            item,
            picid,
            url,
          },
        })
      );
    } catch (e) {
      error(e);
      reportPicShrinkError();
    }
  }
}

window.customElements.define('picupload-list', PicUploadList);

export { PicUploadList };
